import { styled } from "../theme";
const defaultComponents = {
    Wrapper: styled.div `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    flex-wrap: wrap;

    & > * {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
  `,
    Left: styled.div `
    display: flex;
  `,
    Right: styled.div `
    display: flex;
    margin: 0;
  `,
};
export const FormHeader = ({ children, ...props }) => children(props);
FormHeader.defaultProps = defaultComponents;
